"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Autocomplete = void 0;
const React = __importStar(require("react"));
const merlin_hooks_1 = require("@travelnest/merlin-hooks");
const AutocompleteView_1 = require("./AutocompleteView");
function Autocomplete({ fetch, onSelect, resultsToDisplay, onFocus, debounceFetchCalls }) {
    const [results, setResults] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(false);
    const getData = (value) => __awaiter(this, void 0, void 0, function* () {
        setError(false);
        setLoading(true);
        try {
            setResults(yield fetch(value));
        }
        catch (e) {
            setResults([]);
            setError(true);
        }
        setLoading(false);
    });
    const fetchData = debounceFetchCalls >= 1 ? (0, merlin_hooks_1.useDebouncedCallback)(getData, debounceFetchCalls) : getData;
    return React.createElement(AutocompleteView_1.AutocompleteView, { resultsToDisplay: resultsToDisplay, loading: loading, results: results, onFocus: onFocus ? onFocus : undefined, error: error, onSelect: (item) => {
            setResults([]);
            if (onSelect)
                onSelect(item);
        }, onChange: (value) => {
            if (!value) {
                // clear result list if input is blank
                setResults([]);
            }
            else {
                // fetch data when value is entered
                fetchData(value);
            }
        } });
}
exports.Autocomplete = Autocomplete;
//# sourceMappingURL=Autocomplete.js.map